import { UserGroupMember } from './user-group-member.model';
import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * Container class for user group information
 *
 * @export
 * @class UserGroup
 */
@JsonObject()
export class UserGroup {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
  @JsonProperty('Description') description: string;
  @JsonProperty({ name: 'Members', type: UserGroupMember }) members: Array<UserGroupMember>;
}
